import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Toasts, useCopyToClipboard } from '@fourthwall/components';
import { ShopStatusDropdownExtended } from '@fourthwall/module-shop-status-switch';
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { routing } from '@utils/routing';
export const ShopStatusDropdownDesktop = () => {
    const { copyToClipboard } = useCopyToClipboard();
    const navigate = useNavigate();
    const { timezone } = useShopTime();
    return (React.createElement(ShopStatusDropdownExtended, { size: "small", position: "bottom-start", timezone: timezone, onSettingsClick: () => {
            navigate(routing.settings.domain.self);
        }, onDuplicateClick: (url) => {
            copyToClipboard(url);
            Toasts.notify('Copied to clipboard', { type: 'info' });
        } }));
};
